import { useState } from "react";
import { MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";

const MAP_SRC = "https://maps.google.com/maps?q=Wildenreuth+A+55,+92681+Erbendorf,+Germany&t=&z=15&ie=UTF8&iwloc=&output=embed";

export const ConsentMap = () => {
  const [show, setShow] = useState(false);

  if (show) {
    return (
      <div className="h-64 overflow-hidden" data-testid="contact-map">
        <iframe src={MAP_SRC} width="100%" height="100%" style={{ border: 0 }} allowFullScreen="" loading="lazy"
          referrerPolicy="no-referrer-when-downgrade" title="Auto Thurm Standort" />
      </div>
    );
  }

  return (
    <div className="h-64 bg-[#F2F2F2] flex flex-col items-center justify-center text-center p-6 gap-3" data-testid="contact-map-placeholder">
      <MapPin className="w-8 h-8 text-black" />
      <p className="text-sm text-[#888B8D] max-w-sm">
        Beim Laden der Karte werden Daten (u. a. Ihre IP-Adresse) an Google übertragen.
        Mehr dazu in unserer <a href="/datenschutz#google-maps" className="underline text-black">Datenschutzerklärung</a>.
      </p>
      <Button onClick={() => setShow(true)} className="bg-black text-[#EFDF00] hover:bg-[#222] font-bold" data-testid="contact-map-load-btn">
        Karte laden
      </Button>
    </div>
  );
};
